import styled, {css} from 'styled-components';
import {device} from 'styled/device';

export const ClipContainer = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: #385cf8;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 3px 4px #0002032b;

  & > img {
    width: 22px;
    height: 22px;
  }
`;

export const ClearButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin-left: 15px;
`;

export const ClearIcon = styled.img`
  height: 15px;
  width: 15px;
  border-radius: 3px;
  cursor: pointer;
  vertical-align: middle;

  &:active {
    opacity: 0.95;
  }

  &:hover {
    box-shadow: 0 3px 3px #0f477734;
    transition: box-shadow 0.15s ease-in-out;
  }
`;

export const HiddenFileUploader = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
`;

export const Placeholder = styled.span`
  font-size: 18px;
  position: relative;
  font-family: Poppins, sans-serif;
  opacity: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: rgb(129, 129, 163);

  @media (max-width: ${device.mobileL}) {
    font-size: 20px;
  }
`;

export const inputStyles = css`
  width: 100%;
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 16px;
  transition: background-color 0.25s ease-in-out, border-color 0.05s ease-in-out;
  color: #353945;
  padding: 13px 16px 13px 7px;
  box-sizing: border-box;
  border-radius: 7px;
  border: 1px solid #a2a2b4;
  height: 50px;
  &.invalid
      border-color: #F84B7A;

  &::placeholder
      font-family: inherit;
      color: #B1B5C3;
      opacity: 1;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button
      -webkit-appearance: none;
      margin: 0;
      -moz-appearance: textfield;
`;

export const FileInputBox = styled.div`
  ${inputStyles};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FileNameContainer = styled.div`
  height: 24px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  max-width: 85%;
  background-color: #f0f0f8;
  padding-left: 8px;
  padding-right: 4px;
  border: 1px solid #acacd5;
  border-radius: 4px;

  &:hover {
    cursor: default;

    &&& + ${ClipContainer} {
      opacity: 1;
    }
  }
`;

export const FileName = styled.span`
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: #161643;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 190px;
`;

type FileInputLabelProps = {
  disabled?: boolean;
  invalid?: boolean;
};

export const FileInputLabel = styled.label<FileInputLabelProps>`
  outline: none;
  display: inline-block;
  font-family: Poppins, sans-serif;
  width: 100%;
  cursor: pointer;
  font-size: 14px;
  box-sizing: border-box;
  transition: all 0.07s ease-in-out;
  text-align: left;
  position: relative;

  &:hover ${ClipContainer} {
    opacity: 0.88;
  }

  &:active {
    opacity: 1;
  }

  ${props =>
    props.invalid &&
    css`
      & ${FileInputBox} {
        border-color: #ff2467;
      }
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;

      &:hover,
      &:active {
        opacity: 0.3;

        & ${ClearIcon} {
          cursor: not-allowed;
          opacity: 1;
          box-shadow: none;
        }

        & ${FileNameContainer} {
          cursor: not-allowed;
        }
      }
    `};

  @media (max-width: ${device.mobileS}) {
    width: 293px;
  }
`;
